<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Through villages and old towns</h1>
    <div class='tourPic'>
      <img src='@/assets/cultours/tour4/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>The objective of this four-day tour is to introduce you to the most prominent Montenegrin old towns but also to rural areas by spending as much time there as possible. Old towns will tell us a story about their famous past whilst the villages will reveal the way of life in remote areas.   </p>
            <p class='pasus'>The route will encompass the UNESCO protected Kotor, Montenegrin Pompeii – the old town of Bar, the old town of Ulcinj famous for its pirate past and possibly even for the Cervantes’s, the old Podgorica with its Ottoman heritage, Cetinje as the symbol of Montenegrin independence and fight for freedom, the highest mausoleum in Europe dedicated to the most celebrated Montenegrin of all times but also the most famous Montenegrin villages, the areas known for their vine, smoked ham, olives, chestnuts, cheese and mead, for its architecture and beautiful natural environment. We will pay a visit to a number of cultural-historical monuments and museums and meet some interesting locals.   </p>
            <p class='pasus'>The special segment of the tour includes spectacular viewpoints whereby each day we will enjoy different scenery.  </p>
            <p class='pasus'>In physical terms, the tour is not demanding. We will make sure to walk and spend time in different places only as much as you want, not disrupting the program we agreed upon. While on this tour you will get to know the border areas of Montenegro inhabited by minorities, where different cultures intertwine and Islam, Catholicism and Orthodoxy harmoniously coexist.    </p>
            <p class='pasus'>You will spend time in the areas known for their dairy delicacies, all kinds of fish, olives but also a homegrown fruits and vegetables. You will have the opportunity to taste famous Montenegrin smoked ham and red wine, mead and brandy.  </p>
            <p class='pasus'>Ultimately, local people will always welcome us politely and proudly.  </p>
            <p class='pasus'>Cheers! </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>
              Availability: May – October
            </p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>
              Departure from: Podgorica
            </p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 5 days / 4 nights</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
                    <ul class='collapse itinerary_days' id='itinerary'>
          <li>
            <a data-toggle='collapse' href='#day1'> <h5 class='sub-titles'>Day 1  -  The arrival day, Podgorica old town and a journey through the territory of Kuči tribe</h5></a>
            <div class='collapse' id='day1'>
              <p class='pasus'>After you land at Podgorica airport your driver/guide will meet you at the exit hall carrying a sign with your name. After a short introduction, we will head towards Podgorica.  </p>
              <p class='pasus'>The first day is reserved for the capital city and its mountainous hinterland. We will stretch our legs by taking a walk down the old Podgorica, built according to the Ottoman pattern – with narrow and winding streets, mosques and houses in oriental style. Once we are done, we will head towards the nearby mountains ascending from 50 to 1300m above sea level in a short time. We will pass the territory of one of the most famous among Montenegrin tribes – Kuči tribe, enjoy rural mountainous scenery and pay a visit to a memorial museum of Montenegrin hero and writer Marko Miljanov to finally reach the mountain plateau near the Albanian border where we can walk to the spectacular lookout with a view on the highest peaks of Prokletije mountain range.    </p>
              <p class='pasus'>On our way back we can refresh in a charming mountain tavern, have a local drink and breathe deeply clear mountain air.   </p>
              <p class='pasus'>Accommodation – hotel 4* Podgorica  </p>
              <!-- <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 2.5 hours</p>
                <p> <i class='fas fa-route'></i> 140 km</p>
              </div> -->
              <img class='daypic' src='@/assets/cultours/tour4/day1.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day2'> <h5 class='sub-titles'>Day 2 - Along the coast of Skadar Lake, among vineyards, chestnut trees and olives</h5></a>
            <div class='collapse' id='day2'>
              <p class='pasus'>On our second day we will visit the area around the largest lake in the Balkans – Skadar Lake, merely 20km away from Podgorica, which one part belongs to the national park of the same name as well as the old town of Ulcinj and the southernmost part of Montenegrin coast. The substantial part of the day will be spent in the border area giving us the opportunity to discover the way of life of our Albanian neighbors.   </p>
              <p class='pasus'>We will enjoy the panoramic ride through many villages located in the proximity of the lake, make a stop on a few beautiful viewpoints, have the chance to taste some of the local products, take a walk through Godinje village known for its architecture and wine, walk through the chestnut forest and finally visit the old town of Ulcinj, famous for stories about pirates, Cervantes and life with the sea.    </p>
              <p class='pasus'>On our way back we will drive through the ancient olive groves and pay homage to the oldest olive tree in Europe.  </p>
              <p class='pasus'>Accommodation- hotel 4* Podgorica </p>
              <!-- <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3 hours</p>
                <p> <i class='fas fa-route'></i> 100 km</p>
              </div> -->
              <img class='daypic' src='@/assets/cultours/tour4/day2.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day3'><h5 class='sub-titles'>Day 3  -  Old Montenegro - Montenegrin Olympus and stories about free people and spirituality</h5></a>
            <div class='collapse' id='day3'>
              <p class='pasus'>We will visit the area that brought forth the modern Montenegrin state, concentrated around the symbol of Montenegro’s freedom – Lovcen Mountain, an old capital of Montenegro – Cetinje; we will pass through the national park Lovcen, climb up the stairs to the highest mausoleum in the world and enjoy the breathtaking view on one of the most beautiful gulfs on the globe – Boka Bay.  </p>
              <p class='pasus'>The tour will end in the most famous Montenegrin village Njegusi where, if you wish so, you can taste famous smoked ham, cheese, wine or mead. </p>
              <p class='pasus'>We certainly won’t miss the opportunity to once again have a look to the Skadar Lake from the striking lookout Pavlova strana and take a stroll through a charming little town Rijeka Crnojevica resting on the very lake’s shore.  </p>
              <p class='pasus'>Accommodation- hotel 4* Podgorica</p>
              <!-- <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 2 hours</p>
                <p> <i class='fas fa-route'></i> 90 km</p>
              </div> -->
              <img class='daypic' src='@/assets/cultours/tour4/day3.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day4'><h5 class='sub-titles'>Day 4  - Venetian legacy, UNESCO heritage and islands’ legends</h5></a>
            <div class='collapse' id='day4'>
              <p class='pasus'>This day is reserved for the true gems of Montenegrin coast, the pearls of Venetian architecture, the area which was under the governance of Venetian Republic for a few centuries and then a few more under the Austro-Hungarian Monarchy. </p>
              <p class='pasus'>After a one hour of comfortable ride and a few lookouts with a view on Skadar Lake and the Adriatic coast, we will enjoy the morning view onto the fascinating St. Stephen, once a fishermen’s village and nowadays a luxurious town hotel, to arrive to an old town of Kotor in an additional half an hour of drive. We will take a walk down its narrow streets; take a glance at its hidden corners, visit the old churches and cathedrals and, optionally, walk its walls, protected by UNESCO as the old town itself. </p>
              <p class='pasus'>The road will take us further to a magical baroque town of Perast, famous for its maritime history, festivals and numerous legends. We will enjoy a short boat ride to one of the two islands with catholic churches – Our Lady of the Rocks, where in addition to artistically high range of icon making there is a museum testifying about the history of the sanctuary and the surroundings. </p>
              <p class='pasus'>This will also be the opportunity to enjoy the fish delicacies in one of the taverns on the shore or in the old town and taste the famous Kotor cream pie. </p>
              <p class='pasus'>Accommodation - hotel 4* Podgorica</p>
              <!-- <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 1 hour 15 minutes</p>
                <p> <i class='fas fa-route'></i> 60 km</p>
              </div> -->
              <img class='daypic' src='@/assets/cultours/tour4/day4.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day5'><h5 class='sub-titles'>Day 5  -  Departure day</h5></a>
            <div class='collapse' id='day5'>
              <p class="pasus">On the last day you’ll have breakfast as usual. After you finish our driver will pick up your luggage and take you directly to the airport.</p>
            </div>
          </li>
          </ul>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices (based on the number of people in your group):</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>2 persons – 1000 EUR p/person</li>
              <li class='pasus'>4 persons – 700 EUR p/person</li>
              <li class='pasus'>6 persons – 750 EUR p/person</li>
              <li class='pasus'>For bigger groups on request</li>
              <li class='pasus'>Single room supplement: 120 EUR.</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Accommodation for all nights</li>
              <li class='pasus'>Transportation (van/car)</li>
              <li class='pasus'>Breakfast and dinner for all days</li>
              <li class='pasus'>Bottle of water (0,5l) for each day</li>
              <li class='pasus'>Transfer to the airport on the last day</li>
              <li class='pasus'>Entrance fees (for old towns, national park, mausoleum, museums)</li>
              <li class='pasus'>Our assistance 24/7</li>
              <li class='pasus'>Licensed tour guide</li>
              <li class='pasus'>A map of Montenegro</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
            <a data-toggle='collapse' href='#notincluded'> <h4 class='titles'>Not included in price</h4></a>
            <div class='collapse' id='notincluded'>
              <ul class='square'>
                <li class='pasus'>Optional activities</li>
                <li class='pasus'>Lunch, drinks and tips</li>
                <li class='pasus'>Personal expenses</li>
              </ul>
            </div>
          </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>We recommend that you always carry with you a light jacket, a cap, sunglasses and a swimming suit. </li>
              <li class='pasus'>The altitude difference we make is around 1600 meters. We start at 5 meters above sea level and the highest point we reach is at 1660 meters above sea level.     </li>
              <li class='pasus'>Prices at restaurants and cafes are very affordable and we will always recommend those places we have already checked out and which stand out as the best choices in the specific area.  </li>
              <li class='pasus'>The currency is euro </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Wine tasting</li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>Itinerary changes during the tour can be agreed (do not affect the price)</li>
              <li class='pasus'>Zip line</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/cultours/tour4/01.jpg'),
          thumbnail: require('@/assets/cultours/tour4/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour4/day1.jpg'),
          thumbnail: require('@/assets/cultours/tour4/day1.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour4/day2.jpg'),
          thumbnail: require('@/assets/cultours/tour4/day2.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour4/day3.jpg'),
          thumbnail: require('@/assets/cultours/tour4/day3.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour4/day4.jpg'),
          thumbnail: require('@/assets/cultours/tour4/day4.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/CT4_VillagesAndTowns.vue